import styled, { createGlobalStyle } from "styled-components";
import { rotatingShineAnimation } from "../../../TutorialV2/animations";

export const TutorialPanelScale = styled.div<{ $fontSize: number }>`
	font-size: ${({ $fontSize }) => `${$fontSize}px`};
`;

export const LoyaltyBalanceGlobalStyles = createGlobalStyle`
	.MuiAppBar-root.tutorial-loyalty-balance-appbar {
		z-index: 10001;
		pointer-events: none;
	}

	.MuiAppBar-root.tutorial-loyalty-balance-appbar::after {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba(0, 0, 0, 0.6);
		z-index: 1;
		pointer-events: none;
	}

	.MuiAppBar-root.tutorial-loyalty-balance-appbar
		.tutorial-loyalty-balance-anchor {
		position: relative;
		z-index: 3;
	}
`;

export const LoyaltyBalanceShine = styled.img<{
	$left: number;
	$top: number;
}>`
	position: fixed;
	top: ${({ $top }) => `${$top}px`};
	left: ${({ $left }) => `${$left}px`};
	width: 13.2em;
	height: 13.2em;
	font-size: 10px;
	opacity: 0.8;
	z-index: 2;
	pointer-events: none;
	${rotatingShineAnimation}
`;
